import { getActiveRatings, packagerPrefix } from './analysisUtils'

export function anythingEmptyInGeneralInformation(generalInfo: GeneralInfo): boolean {
    const {
        batch,
        sku,
        reference,
        participants,
        weighings,
        isDelayed,
        justificationPlannedEvent,
        justificationText,
        justificationObservationText
    } = generalInfo
    const validParticipants = participants.filter(participant => participant)
    const invalidWeighing = checkForInvalidWeighings(weighings)
    const emptyBatch = !Number(batch)
    const emptySku = !sku
    const emptyReference = !reference && reference !== false
    const noValidParticipants = !validParticipants.length
    const lessThanTwoWeighings = weighings.length < 2
    const analysisIsDelayed = isDelayed && !justificationText && !justificationPlannedEvent?.length
    const isJustificationTextOthers = justificationText === 'OTHERS'
    const ifJustificationObservationTextEmpty =
        !justificationObservationText ||
        justificationObservationText === '' ||
        justificationObservationText.toString().match(/^\s+$/g)
    if (
        emptyBatch ||
        emptySku ||
        emptyReference ||
        noValidParticipants ||
        invalidWeighing ||
        lessThanTwoWeighings ||
        analysisIsDelayed ||
        (isJustificationTextOthers && ifJustificationObservationTextEmpty)
    ) {
        return true
    } else {
        return false
    }
}

export function checkForInvalidWeighings(weighings: IWeighing[]): boolean {
    return weighings.reduce((acc: boolean, weighing, index) => {
        if (!acc) {
            const { packager, weight, grammage } = weighing
            const packagerNumber = Number(packager.split(packagerPrefix)[1])
            const allValuesAreEmpty = !weight && !grammage && !packagerNumber
            const allOfTheValuesAreOk = weight && grammage && packagerNumber
            const weighingIsPartiallyFilled = !allValuesAreEmpty && !allOfTheValuesAreOk
            // at least 2 weighings need to be configured
            const requiredWeighingIsEmpty = index < 2 && !allOfTheValuesAreOk
            if (weighingIsPartiallyFilled || requiredWeighingIsEmpty) {
                acc = true
            }
        }

        return acc
    }, false)
}

export function anyActiveRatingWithoutAScore(
    ratingInfo: RatingInfo,
    urlParams: string[],
    assetTree: CountryData[]
): boolean {
    const possibleScores = [0, 1, 2, 3, 4]
    const activeRatings = getActiveRatings(urlParams, assetTree)
    const ratingValues = activeRatings.map(rating => ratingInfo[rating].score)
    const invalidValues = ratingValues.filter(score => !possibleScores.includes(score))

    return !!invalidValues.length
}

export function anyLowRatingWithoutDeviation(ratingInfo: RatingInfo): boolean {
    const ratingTypes = Object.keys(ratingInfo)

    return ratingTypes.reduce((acc: boolean, ratingType) => {
        if (!acc && ratingInfo[ratingType].score && !ratingInfo[ratingType].deviations.allDeviations.size) acc = true

        return acc
    }, false)
}
